import { render, staticRenderFns } from "./support_center.vue?vue&type=template&id=30ff0dfb&scoped=true"
import script from "./support_center.vue?vue&type=script&lang=js"
export * from "./support_center.vue?vue&type=script&lang=js"
import style0 from "./support_center.vue?vue&type=style&index=0&id=30ff0dfb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ff0dfb",
  null
  
)

export default component.exports